import { render, staticRenderFns } from "./BrandColorPicker.vue?vue&type=template&id=bcaa4656&"
import script from "./BrandColorPicker.vue?vue&type=script&lang=js&"
export * from "./BrandColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports